import { render, staticRenderFns } from "./jf-termin-anmeldung.vue?vue&type=template&id=61894130&scoped=true&lang=pug&"
import script from "./jf-termin-anmeldung.vue?vue&type=script&lang=js&"
export * from "./jf-termin-anmeldung.vue?vue&type=script&lang=js&"
import style0 from "./jf-termin-anmeldung.vue?vue&type=style&index=0&id=61894130&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61894130",
  null
  
)

export default component.exports